import { render } from "./GuidanceCell.vue?vue&type=template&id=5736ba3b&ts=true"
import script from "./GuidanceCell.vue?vue&type=script&lang=ts"
export * from "./GuidanceCell.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src3320913318/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__